import { BENEFIT_MERCHANTS } from "@/enums";
import { homerStore } from "@/store/home";
import { DefaultMerchantInfo } from "@/constants/merchantInfo";
import { tcJumpActivityFinishCurrent, tcJumpActivity } from "@/utils/bridge/index";
export const getAssetsFile = (imgPath: string) => {
  return new URL(`../assets/images/${imgPath}`, import.meta.url).href;
};
/**
 * 检查图片是否存在
 * @param imagePath - 图片的路径
 * @returns Promise 成功则 resolve，失败则 reject
 */
export function checkImageExists(imagePath: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = getAssetsFile(imagePath);

    img.onload = () => resolve();
    img.onerror = () => reject(new Error("图片不存在"));
  });
}

// 图片压缩

import ImageCompressor from "image-compressor.js";
interface ImageCompressorOptions {
  quality?: number; // 压缩质量，0 到 1 之间的数字
  width?: number; // 输出图像的最大宽度
  height?: number; // 输出图像的最大高度
  resize?: boolean; // 是否调整大小，默认是 true
  convertSize?: boolean; // 是否转换尺寸，默认是 false
  checkOrientation?: boolean; // 是否检查图片方向，默认是 true
  success?(result: Blob): void; // 成功回调
  error?(error: any): void; // 错误回调
  [key: string]: any; // 允许额外的属性
}
export function compressFile(file: File): Promise<File> {
  return new Promise((resolve, reject) => {
    let options: ImageCompressorOptions = {
      success(result: Blob) {
        // 将压缩后的 Blob 转换为 File 对象
        const compressedFile = new File([result], file.name, {
          type: file.type,
          lastModified: Date.now(),
        });
        resolve(compressedFile);
      },
      error(e: any) {
        reject(e);
      },
      quality: 1, // 默认质量设置为最高
      convertSize: false,
      checkOrientation: false,
    };

    // 设置不同的压缩质量根据文件大小
    if (file.size > 1 * 1024 * 1024 && file.size <= 3 * 1024 * 1024) {
      options.quality = 0.3;
    } else if (file.size > 3 * 1024 * 1024 && file.size <= 4 * 1024 * 1024) {
      options.quality = 0.2;
    } else if (file.size > 4 * 1024 * 1024 && file.size <= 5 * 1024 * 1024) {
      options.quality = 0.6; // 新增 4-5MB 文件大小范围的处理
    } else if (file.size > 5 * 1024 * 1024 && file.size <= 6 * 1024 * 1024) {
      options.quality = 0.6;
    } else if (file.size > 6 * 1024 * 1024 && file.size <= 7 * 1024 * 1024) {
      options.quality = 0.6;
    } else if (file.size > 7 * 1024 * 1024 && file.size <= 9 * 1024 * 1024) {
      options.quality = 0.6;
    }

    // 实例化 ImageCompressor 并开始压缩
    new ImageCompressor(file, options as any);
  });
}

// 防抖函数
export function debounce<T extends (...args: any[]) => void>(fn: T, delay: number) {
  let timer: ReturnType<typeof setTimeout>;
  return function (...args: Parameters<T>) {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}

// 节流函数
export function throttle<T extends (...args: any[]) => void>(fn: T, delay: number) {
  let lastTime = 0;
  return function (...args: Parameters<T>) {
    const now = Date.now();
    if (now - lastTime >= delay) {
      fn(...args);
      lastTime = now;
    }
  };
}
// 不同资方-客服电话（数据来源：接口 /app/find-semi-process-list）
export const callPhone = (merchantCode: string) => {
  const store = homerStore();
  const config = store.merchantConfigMap[merchantCode] || DefaultMerchantInfo;

  return {
    phoneNumer: config.phoneNumber,
    phoneNumerShow: config.phoneNumberShow,
    customerTime: config.customerTime || "客服时间：9:00-18:00",
  };
};

// 不同资方-跳转借款申请页逻辑(首页)
export const jumpBorrowApply = (item: any, isTestUser: boolean) => {
  const { merchantId, lifeCycle } = item;
  const merchantCode = item?.merchant?.code;
  const loanUrl = BENEFIT_MERCHANTS.has(merchantCode) ? "loanBenefit" : "loanIndex";

  tcJumpActivity(
    `/${loanUrl}?id=${merchantId}&lifeCycle=${lifeCycle}&merchantCode=${merchantCode}&isTestUser=${isTestUser}`
  );
};

// 不通资方-跳转借款确认页逻辑(账号页面)
export const jumpBorrowConfirm = (item: any) => {
  const merchantCode = item?.code;
  const merchantId = item?.merchantId;
  const lifeCycle = item?.lifeCycle;
  const loanUrl = BENEFIT_MERCHANTS.has(merchantCode) ? "loanBenefit" : "loanIndex";

  tcJumpActivityFinishCurrent(
    `/${loanUrl}?id=${merchantId}&lifeCycle=${lifeCycle}&merchantCode=${merchantCode}`
  );
};

// 不同资方-跳转账单详情（还款页面）
export const jumpBillDetail = (item: any, isTestUser: boolean) => {
  const loanMainId = item?.loanMainId;
  const merchantId = item?.merchantId;
  const outstandingPayment = item?.outstandingPayment;
  const status = item?.status;
  const merchantCode = item?.merchantCode;
  const billUrl = BENEFIT_MERCHANTS.has(merchantCode) ? "billDetailBenefit" : "billDetail";

  tcJumpActivity(
    `/${billUrl}?id=${loanMainId}&merchantId=${merchantId}&outstandingPayment=${outstandingPayment}&status=${status}&merchantCode=${merchantCode}&isTestUser=${isTestUser}`
  );
};
// 对接商城类 逻辑跳转 判断（数据来源：接口 /app/find-semi-process-list）
export const isThirdPartyPageMerchant = (merchantCode: string) => {
  const store = homerStore();
  return store.thirdPartyMerchantSet.has(merchantCode);
};

/**
 * 强制将 http 链接转换为 https
 * @param url 原始链接
 * @returns 转换后的 https 链接
 */
export function forceHttps(url: string): string {
  if (!url) return url;
  return url.replace(/^http:\/\//i, "https://");
}
